// src/utils/auth.js — token & user helpers
export const TOKEN_KEY = 'beo_token';

export function getToken() { return localStorage.getItem(TOKEN_KEY); }
export function setToken(t) { if (t) localStorage.setItem(TOKEN_KEY, t.trim()); else localStorage.removeItem(TOKEN_KEY); }
export function removeToken() { localStorage.removeItem(TOKEN_KEY); }

export async function logout() {
  try {
    const { API_BASE } = await import('./api');
    await fetch(API_BASE + '/api/logout', { 
      method: 'POST',
      credentials: 'include'
    });
  } catch (err) {
    console.error('Logout API call failed:', err);
  } finally {
    removeToken();
    window.location.href = '/login';
  }
}

export function decodeToken(token) {
  try {
    const payload = (token || '').split('.')[1];
    if (!payload) return null;
    return JSON.parse(atob(payload));
  } catch { return null; }
}

export function getUser() { return decodeToken(getToken()); }
export function isLoggedIn() { return !!getToken(); }
